import React, { Component } from 'react';
import logo from '../../images/Godrej_Logo.png';
import './Header.css';

export default class Header extends Component {
  render() {
    return (
      <div className="header-class">
        <img src={logo} className="header-logo" alt="Godrej Logo" />
        <h1 className="header-title">Training System Appliances</h1>
        <span className="header-company">Godrej Enterprises Group</span>
      </div>
    );
  }
}
